export default "__VITE_ASSET__BZVu75si__"